import {React} from "react";
import styled  from "styled-components";
import imgController from '../img/controller.jpg'
import imgApp from '../img/app.PNG'
import imgJean from '../img/Jean.jpg'
import imgOverzicht from '../img/overzicht.jpg'


const IpCarContainer = styled.div`

    position: relative;
    padding-top: 100px;
    width: 100%;
    height: 100%;
    color: white;
    z-index: 1;

    iframe{
      width: 50vw;
      height: calc(50vw/1.77);
    }
   
    h1{
      padding-top: 50px;
      margin:0;
      margin-left:20%;
      text-align: left;
    }
    p{
      text-align: left;
      width: 60%;
      margin-left:20%;
      
    }

  @media only screen and (max-width: 500px) {

      iframe{
        width: 90vw;
        height: calc(90vw/1.77);
       }
    
       h1{
        margin-left:10%; 
      }

      p{
        text-align: left;
        width: 80%;
        margin-left:10%;  
      }
}
`
const ImgContainer = styled.div`
padding-top: 50px;
width: 90%;
height:100%;
margin-left:5%;


`

const Row = styled.div`
   width: 100%;
  margin: auto;


  img{
    display: block;
  width: 80%;
  height: auto;
  margin: auto;
  padding-bottom: 50px;
  }
`

function Ipcar() {


  return (
    <IpCarContainer>
      <iframe 
              src="https://www.youtube.com/embed/rWkAk9bbLmA?modestbranding=0&autohide=1&showinfo=1&controls=0&autoplay=1"
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen>
            </iframe>
            <h1>IP-Car</h1>
            <p>De IP-Car is een via internet aangestuurde robot auto. Ontwikkeld voor mensen met een lichamelijke beperking. 
                Met de IP-Car kunnen zij het buitenleven ervaren zonder zelf naar buiten te gaan. Door de rolstoel waar zij vaak inzitten komen ze niet of lastig in parken, bossen stranden, etc.
                Met de IP-Car kunnen zij als nog digitaal van deze locaties genieten.
            </p>
            <p>De IP-Car kan worden bestuurd met een Playstation controller, touch screen van een smartphone en een opmaat gemaakte controller. Door een live video verbinding 
              kan men zien wat de IP-Car in realtime filmt. De kern van de IP-Car bestaat uit een Raspberry Pi 4 met 4G dongle voor internet.
              Hierdoor kan de IP-car bestuurt worden over enorme afstanden. Doormiddel van webApp kan men de verbinding met de IP-Car maken. 
      
            </p>

            <ImgContainer>
              <Row>
            
                  <img src={imgController} alt="Controller"  />
           
      
                  <img src={imgApp} alt="App"/>
          
                
              </Row>
              <Row>
           
                  <img src={imgOverzicht} alt="Everything"  />
         
           
                  <img src={imgJean} alt="Jean using the IP-Car"/>
             
                
              </Row>
            </ImgContainer>
    </IpCarContainer>
  );
}
export default Ipcar;